import type { Project } from './types';

/** Portfólio curado a partir do legado de portfolio-2020. */
export const projects: Project[] = [
  {
    id: 'site-unicef',
    category: 'web',
    image: '/portfolio/busca-ativa/lp/screen.jpg',
    images: [
      '/portfolio/busca-ativa/lp/screen.jpg',
      '/portfolio/busca-ativa/lp/1.jpg',
    ],
    link: 'https://buscaativaescolar.org.br/',
    i18n: {
      'pt-BR': {
        title: 'Site | UNICEF',
        text: 'Portal nacional de combate à evasão escolar, com alto impacto social e visibilidade pública. Desenvolvimento front-end do site institucional. Stack: HTML, SASS, JavaScript. Desafio: interface clara e acessível para público amplo, com boa performance em dispositivos variados.',
        technology: 'HTML | SASS | JavaScript',
      },
      en: {
        title: 'Website | UNICEF',
        text: 'National portal to combat school dropout, with high social impact and public visibility. Front-end development of the institutional website. Stack: HTML, SASS, JavaScript. Challenge: clear, accessible interface for a broad audience with solid performance across devices.',
        technology: 'HTML | SASS | JavaScript',
      },
    },
  },
  {
    id: 'site-porto-seguro',
    category: 'web',
    image: '/portfolio/pseg/site/aluguel/screen.jpg',
    images: [
      '/portfolio/pseg/site/aluguel/screen.jpg',
      '/portfolio/pseg/site/aluguel/1.jpg',
      '/portfolio/pseg/site/aluguel/2.jpg',
      '/portfolio/pseg/site/aluguel/3.jpg',
      '/portfolio/pseg/site/aluguel/4.jpg',
      '/portfolio/pseg/site/aluguel/5.jpg',
      '/portfolio/pseg/site/aluguel/6.jpg',
      '/portfolio/pseg/site/aluguel/7.jpg',
      '/portfolio/pseg/site/aluguel/8.jpg',
    ],
    i18n: {
      'pt-BR': {
        title: 'Site | Porto Seguro',
        text: 'Portal de seguro aluguel residencial para a Porto Seguro. Implementação front-end de layouts e interações. Stack: HTML, SASS, jQuery. Desafio: consistência visual entre páginas e formulários em produto regulado.',
        technology: 'HTML | SASS | jQuery',
      },
      en: {
        title: 'Website | Porto Seguro',
        text: 'Residential rental insurance portal for Porto Seguro. Front-end implementation of layouts and interactions. Stack: HTML, SASS, jQuery. Challenge: visual consistency across pages and forms in a regulated product.',
        technology: 'HTML | SASS | jQuery',
      },
    },
  },
  {
    id: 'landing-page-porto-seguro',
    category: 'web',
    image: '/portfolio/pseg/lp/instituto/screen.jpg',
    images: [
      '/portfolio/pseg/lp/instituto/screen.jpg',
      '/portfolio/pseg/lp/instituto/1.jpg',
      '/portfolio/pseg/lp/instituto/2.jpg',
    ],
    i18n: {
      'pt-BR': {
        title: 'Landing Page | Porto Seguro',
        text: 'Landing institucional do Instituto Porto Seguro. Desenvolvimento front-end da página de campanha. Stack: HTML, SASS, jQuery. Desafio: conversão e clareza de mensagem em página única, otimizada para campanha.',
        technology: 'HTML | SASS | jQuery',
      },
      en: {
        title: 'Landing Page | Porto Seguro',
        text: 'Institutional landing page for Instituto Porto Seguro. Front-end development of the campaign page. Stack: HTML, SASS, jQuery. Challenge: conversion and message clarity on a single page optimized for the campaign.',
        technology: 'HTML | SASS | jQuery',
      },
    },
  },
  {
    id: 'site-tenda-mobile',
    category: 'web',
    image: '/portfolio/tenda/novo-site-mobile/screen.jpg',
    images: [
      '/portfolio/tenda/novo-site-mobile/screen.jpg',
      '/portfolio/tenda/novo-site-mobile/1.jpg',
      '/portfolio/tenda/novo-site-mobile/2.jpg',
      '/portfolio/tenda/novo-site-mobile/3.jpg',
      '/portfolio/tenda/novo-site-mobile/4.jpg',
      '/portfolio/tenda/novo-site-mobile/5.jpg',
      '/portfolio/tenda/novo-site-mobile/6.jpg',
      '/portfolio/tenda/novo-site-mobile/7.jpg',
      '/portfolio/tenda/novo-site-mobile/8.jpg',
      '/portfolio/tenda/novo-site-mobile/9.jpg',
      '/portfolio/tenda/novo-site-mobile/10.jpg',
      '/portfolio/tenda/novo-site-mobile/11.jpg',
      '/portfolio/tenda/novo-site-mobile/12.jpg',
      '/portfolio/tenda/novo-site-mobile/13.jpg',
      '/portfolio/tenda/novo-site-mobile/14.jpg',
      '/portfolio/tenda/novo-site-mobile/15.jpg',
      '/portfolio/tenda/novo-site-mobile/16.jpg',
      '/portfolio/tenda/novo-site-mobile/17.jpg',
      '/portfolio/tenda/novo-site-mobile/18.jpg',
      '/portfolio/tenda/novo-site-mobile/19.jpg',
      '/portfolio/tenda/novo-site-mobile/20.jpg',
      '/portfolio/tenda/novo-site-mobile/21.jpg',
    ],
    link: 'http://www.tenda.com.br',
    i18n: {
      'pt-BR': {
        title: 'Site | Tenda Mobile',
        text: 'Versão mobile do portal Tenda, alinhada à experiência do app. Front-end responsivo e adaptação de fluxos mobile. Stack: HTML, CSS, JavaScript. Desafio: paridade de experiência entre app e web em dispositivos móveis.',
        technology: 'HTML | CSS | JavaScript',
      },
      en: {
        title: 'Website | Tenda Mobile',
        text: 'Mobile version of the Tenda portal, aligned with the app experience. Responsive front-end and mobile flow adaptation. Stack: HTML, CSS, JavaScript. Challenge: experience parity between app and web on mobile devices.',
        technology: 'HTML | CSS | JavaScript',
      },
    },
  },
  {
    id: 'site-tenda',
    category: 'web',
    image: '/portfolio/tenda/mosaico/screen.jpg',
    images: [
      '/portfolio/tenda/mosaico/screen.jpg',
      '/portfolio/tenda/mosaico/1.jpg',
      '/portfolio/tenda/mosaico/2.jpg',
    ],
    i18n: {
      'pt-BR': {
        title: 'Site | Tenda',
        text: 'Campanha de lançamento de marca: usuários enviavam fotos que formavam um mosaico até revelar a nova identidade. Desenvolvimento da mecânica interativa e integração visual. Stack: HTML, CSS, JavaScript. Desafio: experiência participativa com upload e composição visual em tempo real.',
        technology: 'HTML | CSS | JavaScript',
      },
      en: {
        title: 'Website | Tenda',
        text: 'Brand launch campaign: users uploaded photos that formed a mosaic until the new identity was revealed. Development of the interactive mechanic and visual integration. Stack: HTML, CSS, JavaScript. Challenge: participatory experience with upload and real-time visual composition.',
        technology: 'HTML | CSS | JavaScript',
      },
    },
  },
  {
    id: 'site-pequenos-decoradores',
    category: 'web',
    image: '/portfolio/tenda/pequenos-decoradores/screen.jpg',
    images: [
      '/portfolio/tenda/pequenos-decoradores/screen.jpg',
      '/portfolio/tenda/pequenos-decoradores/1.jpg',
    ],
    i18n: {
      'pt-BR': {
        title: 'Site | Pequenos Decoradores',
        text: 'Portal do concurso Pequenos Decoradores (Tenda). Front-end do site de inscrição e conteúdo do concurso. Stack: HTML, CSS, JavaScript. Desafio: fluxo de inscrição claro para público familiar, em campanha sazonal.',
        technology: 'HTML | CSS | JavaScript',
      },
      en: {
        title: 'Website | Pequenos Decoradores',
        text: 'Pequenos Decoradores contest portal (Tenda). Front-end of the registration and contest content site. Stack: HTML, CSS, JavaScript. Challenge: clear registration flow for a family audience in a seasonal campaign.',
        technology: 'HTML | CSS | JavaScript',
      },
    },
  },
  {
    id: 'site-plano-faixa-preta',
    category: 'web',
    image: '/portfolio/plano/faixa-preta/screen.jpg',
    images: [
      '/portfolio/plano/faixa-preta/screen.jpg',
      '/portfolio/plano/faixa-preta/1.jpg',
    ],
    i18n: {
      'pt-BR': {
        title: 'Site | Plano Faixa Preta',
        text: 'Site institucional para empreendimento Plano & Plano. Implementação front-end de páginas institucionais. Stack: HTML, CSS, JavaScript. Desafio: apresentação de empreendimento imobiliário com hierarquia visual e navegação objetiva.',
        technology: 'HTML | CSS | JavaScript',
      },
      en: {
        title: 'Website | Plano Faixa Preta',
        text: 'Institutional website for a Plano & Plano development. Front-end implementation of institutional pages. Stack: HTML, CSS, JavaScript. Challenge: real estate presentation with clear visual hierarchy and straightforward navigation.',
        technology: 'HTML | CSS | JavaScript',
      },
    },
  },
  {
    id: 'site-share',
    category: 'web',
    image: '/portfolio/share/site/screen.jpg',
    images: [
      '/portfolio/share/site/screen.jpg',
      '/portfolio/share/site/1.jpg',
      '/portfolio/share/site/2.jpg',
      '/portfolio/share/site/3.jpg',
      '/portfolio/share/site/4.jpg',
      '/portfolio/share/site/5.jpg',
      '/portfolio/share/site/6.jpg',
      '/portfolio/share/site/7.jpg',
      '/portfolio/share/site/8.jpg',
      '/portfolio/share/site/9.jpg',
      '/portfolio/share/site/10.jpg',
      '/portfolio/share/site/11.jpg',
      '/portfolio/share/site/12.jpg',
      '/portfolio/share/site/13.jpg',
      '/portfolio/share/site/14.jpg',
      '/portfolio/share/site/15.jpg',
    ],
    link: 'https://sharesl.com.br/',
    i18n: {
      'pt-BR': {
        title: 'Site | Share',
        text: 'Site institucional da Share. Desenvolvimento front-end do portal corporativo. Stack: HTML, SASS, jQuery. Desafio: estrutura de conteúdo corporativo multi-seção, mantendo consistência de marca.',
        technology: 'HTML | SASS | jQuery',
      },
      en: {
        title: 'Website | Share',
        text: 'Share institutional website. Front-end development of the corporate portal. Stack: HTML, SASS, jQuery. Challenge: multi-section corporate content structure while maintaining brand consistency.',
        technology: 'HTML | SASS | jQuery',
      },
    },
  },
  {
    id: 'landing-page-kallas',
    category: 'web',
    image: '/portfolio/kallas/lp/bosque/screen.jpg',
    images: [
      '/portfolio/kallas/lp/bosque/screen.jpg',
      '/portfolio/kallas/lp/bosque/1.jpg',
      '/portfolio/kallas/lp/bosque/2.jpg',
      '/portfolio/kallas/lp/bosque/3.jpg',
      '/portfolio/kallas/lp/bosque/4.jpg',
      '/portfolio/kallas/lp/bosque/5.jpg',
      '/portfolio/kallas/lp/bosque/6.jpg',
      '/portfolio/kallas/lp/bosque/7.jpg',
    ],
    i18n: {
      'pt-BR': {
        title: 'Landing Page | Kallas',
        text: 'Landing de empreendimento imobiliário Bosque da Saúde. Front-end da landing de lançamento. Stack: HTML, SASS, jQuery. Desafio: página de conversão para lançamento, com foco na apresentação visual do empreendimento.',
        technology: 'HTML | SASS | jQuery',
      },
      en: {
        title: 'Landing Page | Kallas',
        text: 'Bosque da Saúde real estate development landing page. Front-end of the launch landing. Stack: HTML, SASS, jQuery. Challenge: conversion page for a launch, focused on visual presentation of the development.',
        technology: 'HTML | SASS | jQuery',
      },
    },
  },
];
